import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\MaterialResource\CreateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/CreateMaterialResourceController.php
* @route '/api/material-resource'
*/
const CreateMaterialResourceController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMaterialResourceController.url(options),
    method: 'post',
})

CreateMaterialResourceController.definition = {
    methods: ["post"],
    url: '/api/material-resource',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\MaterialResource\CreateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/CreateMaterialResourceController.php
* @route '/api/material-resource'
*/
CreateMaterialResourceController.url = (options?: RouteQueryOptions) => {
    return CreateMaterialResourceController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MaterialResource\CreateMaterialResourceController::__invoke
* @see app/Http/Controllers/MaterialResource/CreateMaterialResourceController.php
* @route '/api/material-resource'
*/
CreateMaterialResourceController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateMaterialResourceController.url(options),
    method: 'post',
})

export default CreateMaterialResourceController